import React, { useState } from 'react';

// Material
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import DialogContentText from '@mui/material/DialogContentText';
import IconCheck from '../iconCheck';

// Icons
import SearchIcon from '@mui/icons-material/Search';
import { WarningRounded } from '@mui/icons-material';

// Services
import CustomerService from '../../services/customerService';

// Components
import TextField from '../inputs/input'
import Spinner from '../spinner';
import Dropdown from '../inputs/dropdown';

// Hooks
import useNotify from '../../hooks/notify';
import useUser from '../../hooks/user/useUser';

import { GetDocumentTypeByCountry } from '../../models/EnumEntity';

const CustomersList = ({ selectCustomer, replaceCustomer, validCustomer }) => {
    const {branch} = useUser();
    const { Notify, variants } = useNotify();
    const [loading, setLoading] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [filters, setFilters] = useState({});

    const canSearch = () =>
        filters.documentType !== '-1' &&
        filters.documentNumber &&
        filters.documentNumber.length > 6;

    const handleSearch = () => {
        if (!canSearch()) {
            Notify("Uno o varios parámetros de búsqueda no se encuentran completos", variants.ERROR);
            return;
        }

        setLoading(true);
        CustomerService
            .Search(filters)
            .then(res => {
                const docTypes = GetDocumentTypeByCountry(branch.country);
                const result = res.values.filter(d => docTypes.find(i => i.value === d.documentType))

                if (result.length > 0)
                    setCustomers(result);
                else {                    
                    Notify(`No encontramos ningun cliente con el numero: ${filters.documentNumber}`, variants.INFO)
                    replaceCustomer({ 
                        activeNewsletter: false,
                        country: branch.country,
                        documentNumber: filters.documentNumber ?? '',
                        documentType: filters.documentType ?? '',
                    })
                }
            })
            .catch(() => Notify("Ocurrio un problema al buscar el cliente", variants.ERROR))
            .finally(() => setLoading(false));
    }

    const handleFilterChange = (event) =>
        setFilters({
            ...filters,
            [event.target.name]: event.target.value,
            operationCountry: branch.country
        });

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch()
        }
    }
    const onHandleSelected = async (customer) => {
        selectCustomer(customer);
    };

    return (
        <Grid size={12}>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <DialogContentText>
                        Busca el cliente por <strong>Tipo</strong> y <strong>Numero</strong> de documento.
                    </DialogContentText>
                </Grid>
                <Grid size={12}>
                    <Grid container spacing={1}>
                        <Grid size={4}>
                            <Dropdown
                                fullWidth
                                size='small'
                                name='documentType'
                                label='Tipo de documento'
                                onChange={handleFilterChange}
                                value={filters.documentType || ''}
                                values={ GetDocumentTypeByCountry(branch.country) }
                                disabled={ !branch.country }
                                placeholder='Seleccionar tipo'
                                displayEmpty
                            />
                        </Grid>
                        <Grid size={8}>
                            <TextField
                                fullWidth
                                size='small'
                                name='documentNumber'
                                label='Documento'
                                onChange={handleFilterChange}
                                onKeyPress={handleKeyPress}
                                value={filters.documentNumber || ''}
                            />
                        </Grid>
                        <Grid size={12}>
                            <Button
                                fullWidth
                                disabled={!canSearch()}
                                color='primary'
                                variant='contained'
                                startIcon={<SearchIcon />}
                                onClick={handleSearch}
                            >
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                {   loading &&
                    <>
                        <Grid size={12}>
                            <Divider />
                        </Grid>
                        <Grid container direction='column' alignContent='center' size={12}>
                            <Spinner message='Buscando clientes' />
                        </Grid>
                    </>
                }
                {   !loading && customers?.length > 0 &&
                    <>
                        <Grid size={12}>
                            <Divider />
                        </Grid>
                        {   customers.map((customer, index) => (
                                <Grid key={index} size={12}>
                                    <Card variant='outlined'>
                                        <CardActionArea disabled={!customer.active} onClick={() => onHandleSelected(customer)}>
                                            <CardContent>
                                                <Grid container spacing={1}>
                                                    <Grid size={6}>
                                                        <Typography>
                                                            <strong>Nombre: </strong>{customer.lastName} {customer.firstName}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={6}>
                                                        <Typography>
                                                            <strong>{customer.documentType}: </strong>{customer.documentNumber}
                                                        </Typography>
                                                    </Grid>
                                                    <Box component={Grid} item xs={12} display='flex' gap={2}>
                                                        <Typography>
                                                            <strong>Activo: </strong>
                                                        </Typography>
                                                        <IconCheck value={customer.active} />
                                                    </Box>
                                                    <Grid size={12}>
                                                        <Typography>
                                                            <strong>Email: </strong>{customer.email}
                                                        </Typography>
                                                    </Grid>
                                                    {
                                                        !validCustomer(customer) &&
                                                        <Grid container justifyContent='flex-end' size={1}>
                                                            <Tooltip title='Faltan campos obligatorios'>
                                                                <WarningRounded />
                                                            </Tooltip>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            ))
                        }
                    </>
                }
            </Grid>
        </Grid>
    );
}

export default CustomersList;